import { render, staticRenderFns } from "./buy-now-new-account.vue?vue&type=template&id=08704c93&scoped=true&"
import script from "./buy-now-new-account.vue?vue&type=script&lang=js&"
export * from "./buy-now-new-account.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-new-account.vue?vue&type=style&index=0&id=08704c93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08704c93",
  null
  
)

export default component.exports